import * as React from 'react';
import type { SVGProps } from 'react';

const SvgIconChat = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={20} fill="none" {...props}>
    <path
      fill="#F32A52"
      d="M21.23.73H.43v15.6h6.892l3.508 3.13 3.492-3.13h6.908V.73Zm-1.095 14.505h-6.229L10.83 17.99l-3.09-2.755H1.525V1.825h18.61v13.41Z"
    />
    <path
      fill="#F32A52"
      d="M7.94 8.705a1.779 1.779 0 1 1-3.557 0 1.779 1.779 0 0 1 3.557 0ZM12.883 8.705a1.779 1.779 0 1 1-3.558 0 1.779 1.779 0 0 1 3.558 0ZM17.825 8.705a1.779 1.779 0 1 1-3.558 0 1.779 1.779 0 0 1 3.558 0Z"
    />
  </svg>
);
export default SvgIconChat;
